<template>
	<van-tabbar v-model="active" style="z-index: 1999">
		<van-tabbar-item
			v-for="(tab, index) in tabbar"
			:to="tab.path"
			:dot="tab.dot"
			:info="tab.info"
			:key="index">
			<!-- <van-icon  slot="icon" slot-scope="props"  :name="'icon-'+tab.icon"/> -->
			<i slot="icon" slot-scope="props"  :class="'icon-task icon-'+tab.icon"></i>
			{{tab.name}}
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
  name: 'tabbar',
  props: {
    tabbar: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      active: 0
    }
  },

  watch: {
    '$route': 'changeActive'
  },

  created () {
    const toName = this.$route.name
    this.setActive(toName)
  },

  methods: {
    changeActive ({ name }) {
      this.setActive(name)
    },
    setActive (name) {
      this.tabbar.forEach((tab, i) => {
        if (tab.pathName == name) {
          this.active = i
          return false
        }
      })
      
      // 额外处理：根据路径匹配来设置激活状态
      if (!name && this.$route.path) {
        this.tabbar.forEach((tab, i) => {
          if (tab.path && this.$route.path === tab.path.split('?')[0]) {
            // 对于带参数的路径，进行更灵活的匹配
            if (tab.path.includes('?')) {
              const basePath = tab.path.split('?')[0];
              if (this.$route.path === basePath) {
                // 检查查询参数是否匹配
                const tabParams = this.parseUrlParams(tab.path);
                const routeParams = this.$route.query;
                
                // 检查关键参数是否匹配
                if (tabParams.tab && routeParams.tab === tabParams.tab) {
                  this.active = i;
                  return false;
                } else if (!tabParams.tab) {
                  // 如果tab没有特定参数要求，则路径匹配即可
                  this.active = i;
                  return false;
                }
              }
            } else {
              // 简单路径匹配
              if (this.$route.path === tab.path) {
                this.active = i;
                return false;
              }
            }
          }
        })
      }
    },
    // 解析URL参数的辅助方法
    parseUrlParams(url) {
      const params = {};
      const queryString = url.split('?')[1];
      if (queryString) {
        queryString.split('&').forEach(pair => {
          const [key, value] = pair.split('=');
          params[key] = value;
        });
      }
      return params;
    }
  }
}
</script>